export class D4signAccountBalanceDTO {
    allSignatures: number;
	contractedSignatures: number;
	balanceSignatures: number;
	documentsProcessing: number;
	documentsWaitingToSend: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_models/_dto/d4sign-account-balance.dto.ts